import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView, ICerViewComponent } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from '../../cer/cer-data/cer-data-types';

import { RightsPeriodClient } from '../api';

import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';

const uiCmdRightsPeriodSync: UiCommand = { id: 'RightsPeriodSync', text: 'Synkroniser periode', iconCss: "e-menu-icon e-icons-org e-repeat", tooltipText: 'Synkroniser periode og dan godkendelser', target: ".e-content", needSelection: true };

export class RightsPeriodForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({

      viewMetadata: {
        name: 'rettigheder-periode', dataApiName: 'RightsPeriod', text: 'Perioder',
        primaryKey: 'id', allowEdit: true, allowCreate: true, allowDelete: true
      },
      toolbarCommands: [uiCmdRightsPeriodSync],
      contextMenuCommands: [uiCmdRightsPeriodSync],
      keyboardShortcuts: [{ cmd: uiCmdRightsPeriodSync, code: 'KeyS', alt: false, ctrl: true, shift: true, enabled: true }],
      onCommandEvent: (e => this.onCommand(e)),
      fieldMetadata: [
        { name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', allowEdit: false, visible: false },
        { name: 'name', text: 'Navn', tooltipText: 'Navn på periode', widthType: FieldWidthEnum.L },
        { name: 'path', text: 'Folder', tooltipText: 'Folder for periode på fil-system', widthType: FieldWidthEnum.M },
        { name: 'active', text: 'Aktiv', tooltipText: 'Er perioden aktiv?', format: 'CheckBox' }
      ]
    });
  }

  public onCommand(e: UiCommandEvent) {
    switch (e.commandId) {
      case uiCmdRightsPeriodSync.id:
        const id: number = e.rowData?.id;
        if (id != null) {
          this.syncPeriod(id, e.appComponent);
        }
        break;
    }
  }

  public async syncPeriod(id: number, appComponent: ICerViewComponent) {
    const client = this.context.injector.get(RightsPeriodClient);
    client.syncPeriod(id).subscribe({
      next: (result) => { appComponent.research() },
      error: (error: any) => { this.context.ui.errorApi(error) }
    });
  }
}
